import React, { useState, useEffect } from "react";
import imageExists from "image-exists";
import { useConfig } from "../context";
import ProductApplications from "./ProductApplications";
import Modal360Viewer from "./Product360ViewerPromo";
import ImageZoomViewer from "./ProductImageZoomViewer";
import Comments from "./Comments";


const CatalogueProductItem = (props) => {
  const item = props.item;
  const index = props.index;
  const { fotos360Url, fotosUrl, fotoNd } = useConfig();
  const [imageSource, setImageSource] = useState("");
  const [is360, set360] = useState(false);
  const [isModal360Open, setIsModal360Open] = useState(false);
  const [codeSelected, setCodeSelected] = useState(null);
  const [commentSelected, setCommentSelected] = useState(null);
  const [isImageZoom, setIsImageZoom] = useState(false);

  useEffect(() => {
    if (fotos360Url && fotosUrl && fotoNd) {
      renderImageSource(item.Codigo);
    }
  }, [item.Codigo, fotos360Url, fotosUrl, fotoNd]);

  const openImageZoomModal = () => {
    if (imageSource !== fotoNd) setIsImageZoom(true);
  };

  const closeImageZoomModal = () => {
    setIsImageZoom(false);
  };

  const openAppsModal = (e) => {
    e.preventDefault();
    setCodeSelected(item.Codigo);
  };


  const openComments = (e) => {
    e.preventDefault();
    setCommentSelected(item.Codigo);
  };

  const closeAppsModal = () => {
    setCodeSelected(null);
  };

  const closeCommentsModal = () => {
    setCommentSelected(null);
  };

  const open360Modal = (e) => {
    e.preventDefault();
    setIsModal360Open(true);
  };

  const close360Modal = () => {
    setIsModal360Open(false);
  };

  const renderAvailability = (available) => {
    const badge = "badge ";

    switch (available) {
      case "Disponible":
        return badge + "badge-success";
      case "Consulta":
        return badge + "badge-light";
      case "Próximamente":
        return badge + "badge-warning";
      default:
        break;
    }
  };

  const renderImageSource = (codigo) => {
    const url2D = fotosUrl + codigo.toLowerCase().replace(/-/g, "_") + ".jpg";
    const url360 = fotos360Url + codigo.toUpperCase() + "/images/img_0_0_0.jpg";

    // Prioridad 1: Imagen 2D, Fallback: placeholder
    imageExists(url2D, function (exists) {
      setImageSource(exists ? url2D : fotoNd);
    });

    // Verificar 360 solo para mostrar/ocultar el badge
    imageExists(url360, function (exists) {
      set360(exists);
    });
  };

  return (
    <div className="col-6 col-md-4 col-lg-3 mb-3">
      <div className="product-card">
        {/* Header con Familia */}
        <div className="product-card-header">
          <span className="product-family">{item.Familia}</span>
          {item.Nuevo && (
            <span className="product-badge-new">Nuevo</span>
          )}
        </div>

        {/* Imagen del producto */}
        <div className="product-card-image">
          <img
            src={imageSource}
            alt={item.Codigo}
            onClick={() => openImageZoomModal()}
            style={{ objectFit: "contain" }}
          />
        </div>

        {/* Modales */}
        {isImageZoom && (
          <ImageZoomViewer
            item={item}
            imageSource={imageSource}
            closeModal={closeImageZoomModal}
          />
        )}
        {codeSelected && (
          <ProductApplications
            codigo={item.Codigo}
            closeModal={closeAppsModal}
          />
        )}
        {commentSelected && (
          <Comments
            codigo={item.Codigo}
            closeModal={closeCommentsModal}
          />
        )}
        {isModal360Open && (
          <Modal360Viewer
            index={index}
            item={item}
            catalogo={true}
            closeModal={close360Modal}
          />
        )}

        {/* Código y badges */}
        <div className="product-card-info">
          <div className="product-code-row">
            <span className="product-code">{item.Codigo}</span>
            <span className={`product-availability ${item.Disponibilidad === 'Disponible' ? 'available' : item.Disponibilidad === 'Próximamente' ? 'soon' : 'check'}`}>
              {item.Disponibilidad}
            </span>
          </div>

          {/* Botones de acción */}
          <div className="product-actions">
            <button
              className="product-btn product-btn-apps"
              onClick={(e) => openAppsModal(e)}
              title="Aplicaciones"
            >
              APS
            </button>
            <button
              className="product-btn product-btn-comments"
              onClick={(e) => openComments(e)}
              title="Comentarios"
            >
              <i className="fas fa-comment"></i>
            </button>
            {is360 && (
              <button
                className="product-btn product-btn-360"
                onClick={(e) => open360Modal(e)}
                title="Vista 360°"
              >
                360
              </button>
            )}
            {/* Carrito deshabilitado temporalmente
            <a
              className="product-btn product-btn-buy"
              href={`https://govi.mx/buscar?tab=codigo&codigo=${item.Codigo}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Comprar en GOVI.MX"
            >
              <i className="fas fa-shopping-cart"></i>
            </a>
            */}
          </div>
        </div>

        {/* Detalles del producto */}
        <div className="product-card-details">
          {item.Descripcion ? (
            <p className="product-description">{item.Descripcion}</p>
          ) : (
            <>
              {item.Modelo && (
                <div className="product-detail-row">
                  <span className="detail-label">Modelo</span>
                  <span className="detail-value">{item.Modelo}</span>
                </div>
              )}
              {item.Posicion && (
                <div className="product-detail-row">
                  <span className="detail-label">Posición</span>
                  <span className="detail-value">{item.Posicion}</span>
                </div>
              )}
              {item.Condicion && (
                <div className="product-detail-row">
                  <span className="detail-label">Condición</span>
                  <span className="detail-value">{item.Condicion}</span>
                </div>
              )}
              {item.Agrupacion &&
                item.TipoVehiculo.trim().toUpperCase() !==
                  item.Agrupacion.trim().toUpperCase() && (
                  <div className="product-detail-row">
                    <span className="detail-label">Tipo</span>
                    <span className="detail-value">{item.Agrupacion.toUpperCase()}</span>
                  </div>
                )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CatalogueProductItem;
